import { UserRole } from "../data/model/user-role.model";

export interface NavItem {
  label: string;
  icon: string;
  route: string;
  roles: UserRole[];
   openPopup?: boolean;
    children?: NavItem[];  
}

export const NAVIGATION_ITEMS: NavItem[] = [
  {
    label: 'Home Page',
    icon: 'pi pi-home',
    route: 'dashboard',
    roles: ['uw_assist', 'underwriter']
  },
  {
    label: 'Work View',
    icon: 'pi pi-clipboard',
    route: 'work-view',
    roles: ['uw_assist', 'underwriter']
  },
    {
    label: 'Dashboard',
    icon: 'pi pi-objects-column',
    route: 'dashboard',
    roles: ['agent']
  },
  {
    label: 'Create New Submission',
    icon: 'pi pi-plus',
    route: 'submission',
    roles: ['agent', 'uw_assist', 'underwriter'],
    openPopup: true 
  },
   {
    label: 'Agency Dashboard',
    icon: 'pi pi-building',
    route: '',
    roles: ['uw_assist', 'underwriter'],
    children: [
      {
        label: 'Overview',
        icon: '',
        route: 'agency/overview',
        roles: ['uw_assist', 'underwriter']
      },
    
      {
        label: 'Onboarding Status',
        icon: '',
        route: 'agency/onboarding',
        roles: ['uw_assist', 'underwriter']
      },
    
    ]
  },
  // {
  //   label: 'Create New Submission',
  //   icon: 'pi pi-plus',
  //   route: 'submission',
  //   roles: ['uw_assist'],
  //   openPopup: true
  // }

];

export function getNavigationItemsForRoles(roles: UserRole[]): NavItem[] {
  if (!roles?.length) return [];
  return NAVIGATION_ITEMS.filter(item =>
    item.roles.some(role => roles.includes(role))
  );
}
